import PropTypes from 'prop-types';

import { Link as GatsbyLink } from 'gatsby';
import { Link as MUILink } from '@mui/material';
import theme from '@themes/general.theme';

export const Link = ({ children, to, color = 'primary', ...rest }) => {
  const internal = /^\/(?!\/)/.test(to);

  if (internal) {
    return (
      // todo Remove styling from here
      <GatsbyLink
        to={to}
        style={{
          textDecoration: 'none',
          fontWeight: 'bold',
          color: theme.palette[color ?? 'primary'].main,
        }}
        {...rest}
      >
        {children}
      </GatsbyLink>
    );
  }

  return (
    <MUILink href={to} target={'_blank'} color={color} {...rest}>
      {children}
    </MUILink>
  );
};

Link.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  color: PropTypes.string,
};

Link.defaultProps = {
  children: null,
  to: '',
  color: 'primary',
};
